import { render, staticRenderFns } from "./vipchargedialog.vue?vue&type=template&id=03dff8ea&scoped=true"
import script from "./vipchargedialog.vue?vue&type=script&lang=js"
export * from "./vipchargedialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dff8ea",
  null
  
)

export default component.exports